import moment from "moment";
import BillsRepository from "../../Repository/BillsRepository";
import LedgersRepository from "../../Repository/LedgersRepository";
import { RFTfeature } from "../features/RFTfeature";
import { ConstructionOutlined } from "@mui/icons-material";
// import db from "./db";
import Repo from "../../Repository/Repo";
import { loadGoogleAnalytics } from "../../pages/analytics/analytics";
import { toast } from "react-toastify";


export const  sendEmailNotification = async (value) => {

  return Repo.email({
    request: {
      method: "sendDelayMail",
      data: {
        user: localStorage.getItem("email"), // Replace with the dynamic email if needed
        feature: value, // Replace with the feature name dynamically if required
        delay: "20 secs", // Replace with the dynamic delay value if required
      },
    },
  })
  .then(({ data }) => {
      // toast.success("Email notification sent successfully!");

      console.log("Email notification sent successfully:", data);
    })
    .catch((error) => {
      console.error("Failed to send email notification:", error.message);
    });
};


export const saveInCashInHand = (items, date, bill, state, id, type, temp, storeBill,paymentMethod, bank,cheque,status,billId,clearBalance) => {
  console.log("storeBillll", storeBill)
 console.log(items,"items")
 console.log('stttear', state)
 console.log('bill', bill)
 console.log('stattttt', status)
 const trackingId = "G-9JX2HR95FS";

  let newItems = items.map((item,index)=> {
   item.costPrice = Number(item?.costPrice  || 0)
   item.salePrice = Number(item?.salePrice  || 0)
   item.imeiNumber = Number(item?.imeiNumber)
   item.minQuantity = Number(item?.minQuantity  || 0)
   item.price = Number(item?.price  || 0)
   item.quantity = Number(item?.quantity  || 0)
   item.saleQuantity = Number(item?.saleQuantity  || 0)
   item.steelWeightKg = Number(item?.steelWeightKg  || 0)
   item.steelWeightTotal = Number(item?.steelWeightTotal  || 0)
   return item
  })
  console.log('newItems', newItems)
 let companyCode = localStorage.getItem("companyCode");

    console.log('billNet',bill)

 let gst =
   localStorage.getItem("gst") &&
   localStorage.getItem("gst") != "undefined" &&
   localStorage.getItem("gst") != "disabled"
     ? localStorage.getItem("gst")
     : "";
 let gstType = localStorage.getItem("gstType") || "";
 let paid = state.paid;
//  let newpaid = state.newpaid;
console.log("stateee",state)
 if(state.paid > state.Total && !clearBalance ) {
  paid = state.Total
 }
 

 return Repo.banks({
  request: {
    method: "salesInCashInHand",
    data: {
        company_code: localStorage.getItem("companyCode"),
        ledgerId: id,
        credit:   Number(paid),
        debit: 0,
        billId: billId,
        from: `Bill Number: ${bill}`,
        to: "cashInHand",
        description: `Bill Number:  ${bill}`,
        date: date,
    }
}
 })
 .then((response) => {


 console.log('responseeee', response)
   return response; 
 })
 .catch((error) => {
   console.error("Error saving bill:", error);
   throw error; // Re-throw the error to handle it in the calling code
 });
};


export const saveInBank = (items, date, bill, state, id, type, temp, storeBill,paymentMethod, bank,cheque,status,billId,bankId,clearBalance) => {
  console.log("storeBillll", storeBill)
 console.log(items,"items")
 console.log('stttear', state)
 console.log('bill', bill)
 console.log('stattttt', status)

  let newItems = items.map((item,index)=> {
   item.costPrice = Number(item?.costPrice  || 0)
   item.salePrice = Number(item?.salePrice  || 0)
   item.imeiNumber = Number(item?.imeiNumber)
   item.minQuantity = Number(item?.minQuantity  || 0)
   item.price = Number(item?.price  || 0)
   item.quantity = Number(item?.quantity  || 0)
   item.saleQuantity = Number(item?.saleQuantity  || 0)
   item.steelWeightKg = Number(item?.steelWeightKg  || 0)
   item.steelWeightTotal = Number(item?.steelWeightTotal  || 0)
   return item
  })
  console.log('newItems', newItems)
let paid = state.paid;
  if(state.paid > state.Total && !clearBalance) {
    paid = state.Total
   }

 return Repo.banks({
  request: {
    method: "salesInBanks",
    data: {
        company_code: localStorage.getItem("companyCode"),
        ledgerId: id,
        credit:   Number(paid),
        debit: 0,
        billId: billId,
        from: `Bill Number: ${bill}`,
        to: `${bank}`,
        description: `Bill Number:  ${bill}`,
        date: date,
        bankId:bankId,
    }
}
 })
 .then((response) => {
 console.log('responseeee', response)
   return response; 
 })
 .catch((error) => {
   console.error("Error saving bill:", error);
   throw error; // Re-throw the error to handle it in the calling code
 });
};


export const updateBillInCashInHand = async (copyBill) => {
  console.log("copyBill", copyBill)

 return Repo.banks({
  request: {
    method: "salesInCashInHand",
    data: {
        company_code: localStorage.getItem("companyCode"),
        ledgerId: copyBill.ledger_id,
        credit: Number(copyBill?.new_paid || copyBill?.paid),
        debit: 0,
        billId: copyBill._id,
        from: `Bill Number: ${copyBill.billNumber}`,
        to: "cashInHand",
        description: `Bill Number:  ${copyBill.billNumber}`,
        date: copyBill.date,
    }
}
 })
 .then((response) => {


 console.log('responseeee', response)
   return response; 
 })
 .catch((error) => {
   console.error("Error saving bill:", error);
   throw error; // Re-throw the error to handle it in the calling code
 });
};


export const updateBillInBank = async (copyBill) => {
  console.log("copyBill", copyBill)




 return Repo.banks({
  request: {
    method: "salesInBanks",
    data: {
      company_code: localStorage.getItem("companyCode"),
      ledgerId: copyBill.ledger_id,
      credit: Number(copyBill.paid),
      debit: 0,
      billId: copyBill._id,
      from: `Bill Number: ${copyBill.billNumber}`,
      to: "cashInHand",
      description: `Bill Number:  ${copyBill.billNumber}`,
      date: copyBill.date,
        bankId:copyBill.bankId,
    }
}
 })
 .then((response) => {
 console.log('responseeee', response)
   return response; 
 })
 .catch((error) => {
   console.error("Error saving bill:", error);
   throw error; // Re-throw the error to handle it in the calling code
 });
};

export const returnFullBillInCashInHand = (copyBill) => {
 let companyCode = localStorage.getItem("companyCode");
    console.log('billNet',copyBill)
    
 return Repo.banks({
  request: {
    method: "salesInCashInHand",
    data: {
        company_code: localStorage.getItem("companyCode"),
        ledgerId: copyBill?.ledger_id,
         billId: copyBill._id,
        to: `Bill Number: ${copyBill.billNumber} full Returned`,
        from: "cashInHand",
        description: `Bill Number: ${copyBill.billNumber} full Returned`,
        date: copyBill.date,
        billReturn: true,

    }
}
 })
 .then((response) => {
 console.log('responseeee', response)
   return response; 
 })
 .catch((error) => {
   console.error("Error saving bill:", error);
   throw error; // Re-throw the error to handle it in the calling code
 });
};


export const returnFullBillInBank = (copyBill) => {

 return Repo.banks({
  request: {
    method: "salesInBanks",
    data: {
      company_code: localStorage.getItem("companyCode"),
      ledgerId: copyBill.ledger_id,
       billId: copyBill._id,
      to: `Bill Number: ${copyBill.billNumber} full Returned`,
      from: `${copyBill.bankName}`,
      description: `Bill Number: ${copyBill.billNumber} full Returned`,
      date: copyBill.date,
      billReturn: true,
      bankId:copyBill.bankId
    }
}
 })
 .then((response) => {
 console.log('responseeee', response)
   return response; 
 })
 .catch((error) => {
   console.error("Error saving bill:", error);
   throw error; // Re-throw the error to handle it in the calling code
 });
};




export const returnSelectedInCashInHand = (copyBill,returnAmount) => {
  let companyCode = localStorage.getItem("companyCode");
     console.log('billNet',copyBill)
  return Repo.banks({
   request: {
     method: "salesInCashInHand",
     data: {
         company_code: localStorage.getItem("companyCode"),
         ledgerId: copyBill?.ledger_id,
          billId: copyBill._id,
         to: `Bill Number: ${copyBill.billNumber} items Returned`,
         from: "cashInHand",
         description: `Bill Number: ${copyBill.billNumber} items Returned`,
         date: copyBill.date,
         selectedItemReturn: true,
         debit: returnAmount,

 
     }
 }
  })
  .then((response) => {
  console.log('responseeee', response)
    return response; 
  })
  .catch((error) => {
    console.error("Error saving bill:", error);
    throw error; // Re-throw the error to handle it in the calling code
  });
 };
 
 
 export const returnSelectedInBank = (copyBill,returnAmount) => {
 
  return Repo.banks({
   request: {
     method: "salesInBanks",
     data: {
      company_code: localStorage.getItem("companyCode"),
      ledgerId: copyBill?.ledger_id,
       billId: copyBill._id,
      to: `Bill Number: ${copyBill.billNumber} items Returned`,
      from: `${copyBill.bankName}`,
      description: `Bill Number: ${copyBill.billNumber} items Returned`,
      date: copyBill.date,
      selectedItemReturn: true,
      debit: returnAmount,
      bankId: `${copyBill.bankId}`,

     }
 }
  })
  .then((response) => {
  console.log('responseeee', response)
    return response; 
  })
  .catch((error) => {
    console.error("Error saving bill:", error);
    throw error; // Re-throw the error to handle it in the calling code
  });
 };

export const deleteInCashInHand = (billId) => {


 let companyCode = localStorage.getItem("companyCode");




 

 return Repo.banks({
  request: {
      method: "salesInCashInHand",
      data: {
          company_code: companyCode,
          billId:billId,
          billDeleted: true
      }
  }

 })
 .then((response) => {


 console.log('responseeee', response)
   return response; 
 })
 .catch((error) => {
   console.error("Error saving bill:", error);
   throw error; // Re-throw the error to handle it in the calling code
 });
};






export const deleteInBank = (bankId,billId) => {

 
  let companyCode = localStorage.getItem("companyCode");
 
 
 
 
  
 
  return Repo.banks({
   request: {
       method: "salesInBanks",
       data: {
           company_code: companyCode,
           billId:billId,
           bankId:bankId,
           billDeleted: true
       }
   }
 
  })
  .then((response) => {
 
 
  console.log('responseeee', response)
    return response; 
  })
  .catch((error) => {
    console.error("Error saving bill:", error);
    throw error; // Re-throw the error to handle it in the calling code
  });
 };
 


export const createBill = async (items, date, bill, state, id, type, temp, storeBill,paymentMethod, bank,cheque,status,bankId,clearBalance) => {
   console.log("storeBillll", storeBill)
  console.log(items,"items")
  console.log('stttear', state)
  console.log('bill', )
  console.log('stattttt', status)
  const trackingId = "G-9JX2HR95FS";

  //  let newItems = items.map((item,index)=> {
  //   item.costPrice = Number(item?.costPrice  || 0)
  //   item.minQuantity = Number(item?.minQuantity  || 0)
  //   item.price = Number(item?.price  || 0)
  //   item.quantity = Number(item?.quantity  || 0)
  //   item.saleQuantity = Number(item?.saleQuantity  || 0)
  //   if(item?.steelWeightKg !== undefined && item?.steelWeightKg !== ''  && item.steelWeightKg !== 0) {
  //     item.steelWeightKg = Number(item?.steelWeightKg )

  //   }
  //   if(item.imeiNumber !== undefined && item.imeiNumber !== ''  && item.imeiNumber !== 0) {
  //     item.imeiNumber = Number(item?.imeiNumber)

  //   }
  //   if( item.steelWeightTotal !== undefined &&  item.steelWeightTotal !== '' && item.steelWeightTotal !== 0) {
  //     item.steelWeightTotal = Number(item?.steelWeightTotal)

  //   }
  //   if(item.salePrice !== undefined && item.salePrice !== '' && item.salePrice !== 0) {
  //     item.salePrice = Number(item?.salePrice  || 0)

  //   }
  //   return item
  //  })

  let newItems = items.map((item, index) => {
    let updatedItem = {
        ...item, // Include all existing properties initially
    
    };
    updatedItem.costPrice = Number(item.costPrice || 0);
    updatedItem.minQuantity = Number(item.minQuantity || 0);
    updatedItem.price = Number(item.price || 0);
    updatedItem.quantity = Number(item.quantity || 0);
    updatedItem.saleQuantity = Number(item.saleQuantity || 0);
    // Conditionally include steelWeightKg
    if (item?.steelWeightKg !== undefined && item?.steelWeightKg !== '' && item?.steelWeightKg !== 0) {
        updatedItem.steelWeightKg = Number(item?.steelWeightKg);
    } else {
        delete updatedItem.steelWeightKg; // Remove property if the condition fails
    }

    // Conditionally include steelWeightTotal
    if (item?.steelWeightTotal !== undefined && item?.steelWeightTotal !== '' && item?.steelWeightTotal !== 0) {
        updatedItem.steelWeightTotal = Number(item?.steelWeightTotal);
    } else {
        delete updatedItem.steelWeightTotal; // Remove property if the condition fails
    }

    // Conditionally include imeiNumber
    if (item?.imeiNumber !== undefined && item?.imeiNumber !== '' && item?.imeiNumber !== 0) {
        updatedItem.imeiNumber = item?.imeiNumber;
    } else {
        delete updatedItem.imeiNumber; // Remove property if the condition fails
    }

    // Conditionally include salePrice
    if (item?.salePrice !== undefined && item?.salePrice !== '' && item?.salePrice !== 0) {
        updatedItem.salePrice = Number(item?.salePrice);
    } else {
        delete updatedItem.salePrice; // Remove property if the condition fails
    }

    return updatedItem;
});

   console.log('newItems', newItems)
   let paid = state.paid;
  if(state.paid > state.Total && !clearBalance) {
    paid = state.Total
   }
  let companyCode = localStorage.getItem("companyCode");
  // let billNetwork = localStorage.getItem("billNetwork");
  // console.log('billNetwork',billNetwork)
     console.log('billNet',bill)

  let gst =
    localStorage.getItem("gst") &&
    localStorage.getItem("gst") != "undefined" &&
    localStorage.getItem("gst") != "disabled"
      ? localStorage.getItem("gst")
      : "";
  let gstType = localStorage.getItem("gstType") || "";
  // let saleType = RFTfeature() ? type : "";
  let billData = {
    company_code: localStorage.getItem("companyCode"),
    items: newItems,
    date: date,
    subTotal: state.subTotal,
    discount: state.discount,
    total: state.Total + (state.clearBalance ? state.formallyOutstandings : 0),
    formallyOutstandings: state.clearBalance ? state.formallyOutstandings : 0,
    billNumber: bill,
    seller: localStorage.getItem("token"),
    customer: state.customer,
    ledger_id: id,
    ledger_address:state.ledger_address,
    change: parseInt(state.paid - state.Total),
    paid: Number(paid),
    // saleType: saleType,
    discount_type: state.discountType,
    notes: state.notes,
    warehouseBill: temp == "warehouse" ? true : false,
    storeBill:storeBill,
    incomeTax:state?.propsBill?.income,
    gst:state?.propsBill?.gst,
    furtherTax:state?.propsBill?.further,
    paymentMethod:state?.propsBill?.paymentMethod,
    bankName:state?.propsBill?.bankName,
    cheque:state?.cheque,
    bankId:bankId,
    // ...newItems
     
  };

  
  if (companyCode == 9478 || companyCode == 1495) {
    billData.gst = gst;
    billData.gstType = gstType;
  }
  return BillsRepository.billsModel({
    request: {
      method: "saveBills",
      data: {
        bill: billData,
      },
    },
  })
  .then((response) => {


    console.log('repsonseee', response.data.response.data.bill)
    // Check if the bill was successfully saved
    if (response.data.response.data.bill) {
      console.log('outside')
      // loadGoogleAnalytics(trackingId);

      // Trigger Google Analytics event
      // if (status?.trim().toLowerCase() == "paid" && typeof gtag === "function") {
      //   console.log('.....itemmmm')
      //   gtag("event", "save_bill", {
      //     event_category: "Billing",
      //     event_label: billData.billNumber || "Unnamed Bill",
      //     value: billData.totalAmount || 0, // Track the total amount if available
      //   });
      //  }
      console.log("Google Analytics: Bill saved event sent");
    } else {
      console.error("Bill saving failed:", response.data.error);
    }
    return response; // Return the original response for further processing
  })
  .catch((error) => {
    console.error("Error saving bill:", error);
    throw error; // Re-throw the error to handle it in the calling code
  });
};

// export const createBill = (items, date, bill, state, id, type, temp) => {
//   let saleType = RFTfeature() ? type : "";

//   const billData = {
//     company_code: localStorage.getItem("companyCode"),
//     items: items,
//     date: date,
//     subTotal: state.subTotal,
//     discount: state.discount,
//     total: state.Total,
//     billNumber: bill,
//     seller: localStorage.getItem("token"),
//     customer: state.customer,
//     ledger_id: id,
//     change: parseInt(state.paid - state.Total),
//     paid: state.paid,
//     saleType: saleType,
//     discount_type: state.discountType,
//     notes: state.notes,
//     warehouseBill: temp === "warehouse" ? true : false,
//   };

//   // Use Dexie to add the billData object to IndexedDB
//   db.bills
//     .add(billData)
//     .then(() => {
//       console.log("Bill data saved in IndexedDB.");
//     })
//     .catch((error) => {
//       console.error("Error saving bill data:", error);
//     });
// };

export const updateBill = (Bill) => {
  return BillsRepository.billsModel({
    request: {
      method: "updateBill",
      data: {
        bill: Bill,
      },
    },
  });
};
export const updateSaleLedger = (Bill) => {
  let paid = Bill.paid ? Bill.paid : 0;
  return LedgersRepository.ledgerModel({
    request: {
      method: "updateSaleLedger",
      data: {
        _id: Bill._id,
        sale: {
          srNum: Bill.srNum,
          date: +new Date(),
          detail: `bill updated ${Bill.billNumber}`,
          billNumber: Bill.billNumber,
          totalAmount: 0,
          depositedAmount: paid,
          remainingAmount: 0 - paid,
        },
      },
    },
  });
};
export const getBills = (token) => {
  return BillsRepository.billsModel({
    request: {
      method: "getBillsWithPagination",
      data: {
        company_code: localStorage.getItem("companyCode"),
        next_page_token: token,
      },
    },
  });
};

export const getOutstandings = (token) => {
  return BillsRepository.billsModel({
    request: {
      method: "getOutstandingBills",
      data: {
        company_code: localStorage.getItem("companyCode"),
        next_page_token: token,
      },
    },
  });
};

export const getSearchBills = async (first, second, text) => {
  let start = "";
  let end = "";

  if (first && second) {
    start = moment(first).format("DD-MM-YYYY");
    end = moment(second).format("DD-MM-YYYY");
  }

  let { data } = await BillsRepository.billsModel({
    request: {
      method: "getBillsSearch",
      data: {
        company_code: localStorage.getItem("companyCode"),
        search: text,
        startDate: start,
        endDate: end,
      },
    },
  });
  let bills = [];
  let out = [];
  data.response.data.items.forEach((billItem) => {
    if (billItem.paid  >= billItem.total  || billItem.status == "completed") {
      bills.push(billItem);
    } else{
      out.push(billItem);
    }
  });

  return { bills, out };
};

export const deleteBill = async (bill) => {
  let { data } = await BillsRepository.billsModel({
    request: {
      method: "deleteBill",
      data: {
        password: "deletebillmanagekaro", //only ceo can delete
        bill: {
          company_code: localStorage.getItem("companyCode"),
          ...bill,
        },
      },
    },
  });
};
